import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import AxiosInstance from '../../../helpers/AxiosInstance';
import heroImage from '../../../assets/images/07.jpeg';
import './CNERH.css';

const CNERH = () => {
  const { t } = useTranslation();
  const [categories, setCategories] = useState([]);
  const [books, setBooks] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [booksPerPage] = useState(12);
  const [showPdfModal, setShowPdfModal] = useState(false);
  const [selectedBook, setSelectedBook] = useState(null);
  const [searchQuery, setSearchQuery] = useState('');
  const [searchResults, setSearchResults] = useState([]);
  const [isSearching, setIsSearching] = useState(false);
  const [searchTimeout, setSearchTimeout] = useState(null);
  const [qrCodeCategories, setQrCodeCategories] = useState([]);
  const [selectedQrCategory, setSelectedQrCategory] = useState(null);
  const [activeTab, setActiveTab] = useState('publications'); // 'publications' or 'qr-media'

  useEffect(() => {
    // Load CNERH publications data
    const cnerhPublications = [
      {
        id: 1,
        title: "الذكرى الـ 45 لعيد الاستقلال",
        titleEn: "45th Anniversary of Independence",
        titleFr: "45ème Anniversaire de l'Indépendance",
        category: "الذكرى ال45 للاستقلال",
        categoryEn: "45th Independence Anniversary",
        categoryFr: "45ème Anniversaire de l'Indépendance",
        pdfUrl: `/api/visitor/cnerh/pdf/1`,
        coverImage: `/api/visitor/cnerh/cover/1`,
        description: "منشورات الذكرى الـ 45 لعيد الاستقلال",
        year: 2007
      },
      {
        id: 2,
        title: "الذكرى الـ 50 لعيد الاستقلال",
        titleEn: "50th Anniversary of Independence",
        titleFr: "50ème Anniversaire de l'Indépendance",
        category: "الذكرى ال50 لعيد الاستقلال",
        categoryEn: "50th Independence Anniversary",
        categoryFr: "50ème Anniversaire de l'Indépendance",
        pdfUrl: `/api/visitor/cnerh/pdf/2`,
        coverImage: `/api/visitor/cnerh/cover/2`,
        description: "منشورات الذكرى الـ 50 لعيد الاستقلال",
        year: 2012
      },
      {
        id: 3,
        title: "الذكرى الــ 55 لاندلاع الثورة التحريرية",
        titleEn: "55th Anniversary of the Liberation Revolution",
        titleFr: "55ème Anniversaire de la Révolution de Libération",
        category: "الذكرى ال55 للثورة",
        categoryEn: "55th Revolution Anniversary",
        categoryFr: "55ème Anniversaire de la Révolution",
        pdfUrl: `/api/visitor/cnerh/pdf/3`,
        coverImage: `/api/visitor/cnerh/cover/3`,
        description: "منشورات الذكرى الـ 55 لاندلاع الثورة التحريرية",
        year: 2009
      },
      {
        id: 4,
        title: "دليل الإصدرات 60 الثورة",
        titleEn: "Guide to Publications - Revolution 60",
        titleFr: "Guide des Publications - Révolution 60",
        category: "دليل اصدارات الثورة 60",
        categoryEn: "Revolution 60 Publications Guide",
        categoryFr: "Guide des Publications Révolution 60",
        pdfUrl: `/api/visitor/cnerh/pdf/4`,
        coverImage: `/api/visitor/cnerh/cover/4`,
        description: "دليل الإصدارات بمناسبة الذكرى الـ 60 للثورة التحريرية",
        year: 2014
      },
      {
        id: 5,
        title: "للاستقلال بمناسبـة الذكرى الــ 60",
        titleEn: "For Independence - 60th Anniversary",
        titleFr: "Pour l'Indépendance - 60ème Anniversaire",
        category: "دليل اصدارات الاستقلال 60",
        categoryEn: "Independence 60 Publications Guide",
        categoryFr: "Guide des Publications Indépendance 60",
        pdfUrl: `/api/visitor/cnerh/pdf/5`,
        coverImage: `/api/visitor/cnerh/cover/5`,
        description: "دليل الإصدارات بمناسبة الذكرى الـ 60 للاستقلال",
        year: 2022
      },
      {
        id: 6,
        title: "بمناسبة الذكرى الـ 65 لاندلاع الثورة التحريرية",
        titleEn: "65th Anniversary of the Liberation Revolution",
        titleFr: "65ème Anniversaire de la Révolution de Libération",
        category: "دليل الإصدارات الثورة 65",
        categoryEn: "Revolution 65 Publications Guide",
        categoryFr: "Guide des Publications Révolution 65",
        pdfUrl: `/api/visitor/cnerh/pdf/6`,
        coverImage: `/api/visitor/cnerh/cover/6`,
        description: "دليل الإصدارات بمناسبة الذكرى الـ 65 لاندلاع الثورة التحريرية",
        year: 2019
      },
      {
        id: 7,
        title: "منشورات المركز",
        titleEn: "Center Publications",
        titleFr: "Publications du Centre",
        category: "منشورات المركز",
        categoryEn: "Center Publications",
        categoryFr: "Publications du Centre",
        pdfUrl: `/api/visitor/cnerh/pdf/7`,
        coverImage: `/api/visitor/cnerh/cover/7`,
        description: "منشورات المركز الوطني للدراسات والبحث في الحركة الوطنية وثورة أول نوفمبر 1954",
        year: 2023
      }
    ];

    // Set categories based on publications
    const categories = [
      { id: 1, name: 'الذكرى ال45 للاستقلال', nameEn: '45th Independence Anniversary', nameFr: '45ème Anniversaire de l\'Indépendance' },
      { id: 2, name: 'الذكرى ال50 لعيد الاستقلال', nameEn: '50th Independence Anniversary', nameFr: '50ème Anniversaire de l\'Indépendance' },
      { id: 3, name: 'الذكرى ال55 للثورة', nameEn: '55th Revolution Anniversary', nameFr: '55ème Anniversaire de la Révolution' },
      { id: 4, name: 'دليل اصدارات الثورة 60', nameEn: 'Revolution 60 Publications Guide', nameFr: 'Guide des Publications Révolution 60' },
      { id: 5, name: 'دليل اصدارات الاستقلال 60', nameEn: 'Independence 60 Publications Guide', nameFr: 'Guide des Publications Indépendance 60' },
      { id: 6, name: 'دليل الإصدارات الثورة 65', nameEn: 'Revolution 65 Publications Guide', nameFr: 'Guide des Publications Révolution 65' },
      { id: 7, name: 'منشورات المركز', nameEn: 'Center Publications', nameFr: 'Publications du Centre' }
    ];

    // Load QR code categories data with real URLs for redirection
    const qrCodeData = [
      {
        category: "أعلام المقاومة",
        translations: {
          ar: "أعلام المقاومة",
          en: "Resistance Figures",
          fr: "Figures de la Résistance"
        },
        items: [
          { id: 1, title: "الحاج أحمد باي", qrCodeUrl: "https://www.cnerh-nov54.dz/storage/activities/crIhQnbTyAcv0ngCChEZfXayzOlYassGCkS7iTsm.pdf", mediaType: "pdf" },
          { id: 2, title: "بوشوشة", qrCodeUrl: "https://www.cnerh-nov54.dz/storage/activities/vn9uM7BhvPsgeM30hRIFVTeNtZO76j8LCLPgPdMX.pdf", mediaType: "pdf" },
          { id: 3, title: "الشيخ آمود", qrCodeUrl: "https://www.cnerh-nov54.dz/storage/activities/Au3iMjJuAL9wp7tSrqbF96rb4bA26wylKlZh3JG5.pdf", mediaType: "pdf" },
          { id: 4, title: "الأمير عبد القادر", qrCodeUrl: "https://www.cnerh-nov54.dz/storage/activities/TJOv3MDWgxb1vWvOaDziDQ8rjttUpYyN5gBd4je6.pdf", mediaType: "pdf" },
          { id: 5, title: "بن ناصر بن شهرة", qrCodeUrl: "https://www.cnerh-nov54.dz/storage/activities/QM3DEZkH4iaRTHGz7qEmUTM6Br5CAgFsW1G76ohY.pdf", mediaType: "pdf" },
          { id: 6, title: "لالة فاطمة نسومر", qrCodeUrl: "https://www.cnerh-nov54.dz/storage/activities/66B5Ue4yhFR5tun9hDMWgHHCHV692mExDrqWs0Du.pdf", mediaType: "pdf" },
          { id: 7, title: "الشيخ بوعمامة", qrCodeUrl: "https://www.cnerh-nov54.dz/storage/activities/zAxqg6maQCh0Sg5fLV46UqFLjQoUcQMkxFrKGX5x.pdf", mediaType: "pdf" },
          { id: 8, title: "الشريف بومعزة", qrCodeUrl: "https://www.cnerh-nov54.dz/storage/activities/hethncHgGQq12tynPVIco2m3B6tgYsn8idoiGREZ.pdf", mediaType: "pdf" },
          { id: 9, title: "المقراني", qrCodeUrl: "https://www.cnerh-nov54.dz/storage/activities/OGgYZBBZ0OLT3zEnqxIHmqrUgcqmT6fpn6Dl2Moi.pdf", mediaType: "pdf" },
          { id: 10, title: "الشريف بوبغلة", qrCodeUrl: "https://www.cnerh-nov54.dz/storage/activities/zImAkbQly8UhW8oMtkGnVdvqM2Hff6NHM96GChLu.pdf", mediaType: "pdf" }
        ],
        count: 10
      },
      {
        category: "مترجمات",
        translations: {
          ar: "مترجمات",
          en: "Translations",
          fr: "Traductions"
        },
        items: [
          { id: 11, title: "مع الأمير عبد القادر", qrCodeUrl: "https://www.cnerh-nov54.dz/storage/documents_files/570mTxDTcny7Y6jWGGDcSToU7NquU5PDPn4VQcxD.pdf", mediaType: "pdf" },
          { id: 12, title: "التعذيب وممارسات الجيش الفرنسي أثناء ثورة التحرير الجزائرية", qrCodeUrl: "https://www.cnerh-nov54.dz/storage/documents_files/OqROUb4QXDm061HU8c9rUuLbT3LMQGymuNhvC1dk.pdf", mediaType: "pdf" }
        ],
        count: 2
      },
      {
        category: "LIVRE QRCODE",
        translations: {
          ar: "كتب",
          en: "Books",
          fr: "Livres"
        },
        items: [
          { id: 13, title: "شموع الذاكرة", qrCodeUrl: "https://drive.google.com/file/d/1x87VlY_np6Cvd5Q9nCvHWIB5HQHEMDmO/view?usp=drive_link", mediaType: "google-drive" },
          { id: 14, title: "أبحاث ودراسات في التاريخ العسكري للثورة الجزائرية", qrCodeUrl: "https://drive.google.com/file/d/1p5HiqedEvVSYc_dZq82nME5KI3dzzxhi/view?usp=drive_link", mediaType: "google-drive" },
          { id: 15, title: "الثورة الجزائرية في الإعلام التركي", qrCodeUrl: "https://drive.google.com/file/d/1YgmLs_0OE8xJ21uWzoi6eQyzZYbV4vTI/view?usp=drive_link", mediaType: "google-drive" },
          { id: 16, title: "الجزائر ومحيطها الإفريقي", qrCodeUrl: "https://drive.google.com/file/d/1K4B9ds5jh6b7JTQyo0qMbkUaZx0Pwqpp/view?usp=drive_link", mediaType: "google-drive" },
          { id: 17, title: "الزيبان في الحركة الوطنية والثورة التحريرية", qrCodeUrl: "https://drive.google.com/file/d/1yYxMzFiGSr5UAhBJgy9-Gt56JNMxUMV2/view?usp=drive_link", mediaType: "google-drive" },
          { id: 18, title: "المعركة الاقتصادية خلال ثورة التحرير الجزائرية", qrCodeUrl: "https://drive.google.com/file/d/1ZcRiS4tfASASFWbAD_u_IOOrbc0hwTE_/view?usp=drive_link", mediaType: "google-drive" },
          { id: 19, title: "الولاية الثانية التاريخية الشمال القسنطيني", qrCodeUrl: "https://drive.google.com/file/d/10eQ7MziuGoRJEphW9tdzBOg4oAQHpukY/view?usp=drive_link", mediaType: "google-drive" },
          { id: 20, title: "الولاية السادسة التاريخية وقائع وأحداث وادي ريغ", qrCodeUrl: "https://drive.google.com/file/d/1VM8lotUTYm8moOSiSRBh2vfDOeMthPkn/view?usp=drive_link", mediaType: "google-drive" },
          { id: 21, title: "ثورة الزوعاطشة 1849", qrCodeUrl: "https://drive.google.com/file/d/12D8GXwj9_ZkCU8TfYfDsRAi1v2wwEfMf/view?usp=drive_link", mediaType: "google-drive" },
          { id: 22, title: "جمعية طلبة شمال إفريقيا المسلمين", qrCodeUrl: "https://drive.google.com/file/d/1FWQ4L99qTXBr46sCGozArbIykOfbtegG/view?usp=drive_link", mediaType: "google-drive" },
          { id: 23, title: "رعاية جزائر الاستقلال لأبناء الشهداء", qrCodeUrl: "https://drive.google.com/file/d/1mkNxgnXP_EfbdZkt3s6iTDtWp_7fdDEv/view?usp=drive_link", mediaType: "google-drive" },
          { id: 24, title: "فرنسا والولايات المتحدة وحرب الجزائر", qrCodeUrl: "https://drive.google.com/file/d/1QBtNp3cG6KDb59Or2ku94j02a5hy7lWZ/view?usp=drive_link", mediaType: "google-drive" },
          { id: 25, title: "مجزرة ساقية سيدي يوسف وتداعياتها", qrCodeUrl: "https://drive.google.com/file/d/1ZRT61hB2lt99BTG9u3W8UMMsXkqanNqf/view?usp=drive_link", mediaType: "google-drive" },
          { id: 26, title: "من قالمة إلى دمشق 1945 وتستمر المجازر الفرنسية", qrCodeUrl: "https://drive.google.com/file/d/1LcHYnL4QhzJdRMZkwIGwLgvHDz5j2NQe/view?usp=drive_link", mediaType: "google-drive" }
        ],
        count: 14
      },
      {
        category: "الذكرى 45     مشاريع البحث2001-2003",
        translations: {
          ar: "الذكرى الـ 45 - مشاريع البحث 2001-2003",
          en: "45th Anniversary - Research Projects 2001-2003",
          fr: "45ème Anniversaire - Projets de Recherche 2001-2003"
        },
        items: [
          { id: 27, title: "آثار السياسة الاستعمارية والاستيطانية في المجتمع الجزائري", qrCodeUrl: "https://drive.google.com/drive/folders/1cTSd4NM9nl2pFPKCSrT81rJDRrD5qSZ1?usp=drive_link", mediaType: "google-drive" },
          { id: 28, title: "استعمال الأسلحة المحرمة دوليا طيلة العهد الاستعماري الفرنسي", qrCodeUrl: "https://drive.google.com/drive/folders/1Ldi0DPPjv8JnK-Y1G1T0lAXkDg0a8uxE?usp=drive_link", mediaType: "google-drive" },
          { id: 29, title: "الاحتلال الاستيطاني وسياسة الرومنة", qrCodeUrl: "https://www.cnerh-nov54.dz/storage/documents_files/BX4KpN4KnvlNRR5CyUnaXBjbfISpqkqVXLRtsdGO.pdf", mediaType: "pdf" },
          { id: 30, title: "الدعم العربي للثورة الجزائرية", qrCodeUrl: "https://www.cnerh-nov54.dz/storage/documents_files/E0ywA58zHq8wXifsNUNTjOd8f1ydZ6qpw8RCQxtY.pdf", mediaType: "pdf" },
          { id: 31, title: "القضية الجزائرية أمام الأمم المتحدة", qrCodeUrl: "https://www.cnerh-nov54.dz/storage/activities/UFQ7KaRjwlKcjB8FGqbgT3kTMdTIGD81Trg9b54X.pdf", mediaType: "pdf" },
          { id: 32, title: "القواعد الخلفية للثورة الجزائرية", qrCodeUrl: "https://www.cnerh-nov54.dz/storage/activities/Gmnc7KLbZKhx8giv4VEyy5xSc1wh1AeI0B8qnhst.pdf", mediaType: "pdf" },
          { id: 33, title: "الهجرة الجزائرية نحو المشرق العربي", qrCodeUrl: "https://www.cnerh-nov54.dz/storage/documents_files/yiW658Sbif9OSnRPLaC83SqEFTCN9wIVwki3Sck5.pdf", mediaType: "pdf" },
          { id: 34, title: "تاريخ الجزائر في العصر الوسيط", qrCodeUrl: "https://www.cnerh-nov54.dz/storage/documents_files/lmGXI7ubIGyhdXoNo0ANzP8sPcf4Y7byKVTrJTn7.pdf", mediaType: "pdf" },
          { id: 35, title: "ثورة أول نوفمبر في صحافة", qrCodeUrl: "https://www.cnerh-nov54.dz/storage/documents_files/jvHBCQuGgqcDUMgCneIjAYz9aLfmIiit1sg8txty.pdf", mediaType: "pdf" },
          { id: 36, title: "كتاب مرجعي حول تاريخ الجزائر في العصر الوسيط", qrCodeUrl: "https://www.cnerh-nov54.dz/storage/documents_files/iYkzHfU7gplvweYQB0zis5UteY0azSTbQFUaQ8ii.pdf", mediaType: "pdf" },
          { id: 37, title: "كتاب مرجعي عن الثورة التحريرية", qrCodeUrl: "https://www.cnerh-nov54.dz/storage/activities/WfUDrekYnR6Ty4UorJoKCYZB9wj5F3zLNWFhth93.pdf", mediaType: "pdf" },
          { id: 38, title: "مساهمة الجزائر في الحضارة العربية الإسلامية", qrCodeUrl: "https://www.cnerh-nov54.dz/storage/documents_files/r7qKEbagEKLZMGkRWNIT085sbe9MKcmzNsyR6RQi.pdf", mediaType: "pdf" },
          { id: 39, title: "موسوعة أعلام الجزائر", qrCodeUrl: "https://www.cnerh-nov54.dz/storage/documents_files/WyNjHHszOsBBKYB879EvI78PlCEu3VHk1wAAJpdT.pdf", mediaType: "pdf" },
          { id: 40, title: "jeunesse sport et revendication nationale", qrCodeUrl: "https://www.cnerh-nov54.dz/storage/documents_files/TYj5uBO9sJlfadgM2HQT1AtIDcXI35lDDY2YifSk.pdf", mediaType: "pdf" },
          { id: 41, title: "استراتيجية العدو الفرنسي لتصفية الثورة الجزائرية", qrCodeUrl: "https://www.cnerh-nov54.dz/storage/documents_files/FI8grfBlkPGUxrr2JVLNnaVVwPx2xGZD6ZicDCDx.pdf", mediaType: "pdf" },
          { id: 42, title: "الأسلاك الشائكة وحقول الألغام", qrCodeUrl: "https://www.cnerh-nov54.dz/storage/documents_files/DED2QcTodJjJC7cHGy4PQnhhTKBvOJkFvWTe3m4A.pdf", mediaType: "pdf" },
          { id: 43, title: "التاريخ العسكري للجزائر", qrCodeUrl: "https://www.cnerh-nov54.dz/storage/documents_files/3PcstZsQoytBFYtxjvSC5BFmTAA4Eur8o7FS11rP.pdf", mediaType: "pdf" },
          { id: 44, title: "التيارات السياسية", qrCodeUrl: "https://www.cnerh-nov54.dz/storage/documents_files/FBTzXppPHnG5lKVlXqt75lekagGYxeSc8MSGj2vm.pdf", mediaType: "pdf" },
          { id: 45, title: "الجرائم الفرنسية والإبادة الجماعية", qrCodeUrl: "https://www.cnerh-nov54.dz/storage/documents_files/IsAC1SnvlpOTIiS8uJCbId1BhVm7kG9hEdBvvQ1O.pdf", mediaType: "pdf" },
          { id: 46, title: "الحواضر والمراكز الثقافية", qrCodeUrl: "https://www.cnerh-nov54.dz/storage/documents_files/QmoBslp6K7zhkLNgFjxPVso8zi9ZkIkCowtb376y.pdf", mediaType: "pdf" },
          { id: 47, title: "الحياة الثقافية في الجزائر خلال العثماني", qrCodeUrl: "https://www.cnerh-nov54.dz/storage/documents_files/cBr06iEWuF42pjUBLGIz2QtrzX5FSd8FUZezK7aX.pdf", mediaType: "pdf" },
          { id: 48, title: "الدولة الجزائرية الحديثة ومؤسساتها", qrCodeUrl: "https://www.cnerh-nov54.dz/storage/documents_files/m14Hr2uudcAxWTQJbofqOMIsXxsfokhtJRd8QWQf.pdf", mediaType: "pdf" },
          { id: 49, title: "العدوان الفرنسي على الجزائر الخلفيات والأبعاد", qrCodeUrl: "https://www.cnerh-nov54.dz/storage/documents_files/LytwBvGgfnmZ160ZPRjmPKwm3ja3g8nyhJYbNRjt.pdf", mediaType: "pdf" },
          { id: 50, title: "العلاقات الأمريكية الجزائرية", qrCodeUrl: "https://www.cnerh-nov54.dz/storage/documents_files/NNbvHb3qiixSGVGUMw854a0ZBcJSNjy9HtnQ1ht3.pdf", mediaType: "pdf" },
          { id: 51, title: "المقاومة والتاريخ العسكري", qrCodeUrl: "https://www.cnerh-nov54.dz/storage/documents_files/VhqfARHdeYyPEAFQ1KQiFQlQm226hFQvAupwuDZE.pdf", mediaType: "pdf" },
          { id: 52, title: "المكنون الحضاري الفينيقي", qrCodeUrl: "https://www.cnerh-nov54.dz/storage/documents_files/zOGuE42W2oFAbK3pjuCo4rPaAmrFT9kCweedUMB0.pdf", mediaType: "pdf" },
          { id: 53, title: "دور المرأة في الثورة التحريرية", qrCodeUrl: "https://www.cnerh-nov54.dz/storage/documents_files/0lRl1UpYq35DBcUzGQpb3jSxqqdDflfGoEzIBqNt.pdf", mediaType: "pdf" },
          { id: 54, title: "منطلقات وأسس الحركة الوطنية الجزائرية", qrCodeUrl: "https://www.cnerh-nov54.dz/storage/activities/7AER7tzfxeZwZO04wvU3gDcustDnbaWrIGikMwM0.pdf", mediaType: "pdf" },
          { id: 55, title: "موسوعة الأعلام الجزائر", qrCodeUrl: "https://www.cnerh-nov54.dz/storage/activities/13zmAXWbs5eU2k7TH5cuH2BT3yrQ9tN5m9HVQj8f.pdf", mediaType: "pdf" }
        ],
        count: 29
      },
      {
        category: "ملتقيات منشورات",
        translations: {
          ar: "ملتقيات",
          en: "Conferences",
          fr: "Rencontres"
        },
        items: [
          { id: 56, title: "8 ماي 1945", qrCodeUrl: "https://www.cnerh-nov54.dz/storage/activities/JvfgDZRMO670ijuoyvSWefhSMDPYEZsqBkYE2SiA.pdf", mediaType: "pdf" },
          { id: 57, title: "amirouche si elhoues", qrCodeUrl: "https://www.cnerh-nov54.dz/storage/documents_files/r7qKEbagEKLZMGkRWNIT085sbe9MKcmzNsyR6RQi.pdf", mediaType: "pdf" },
          { id: 58, title: "dalil mostalahat", qrCodeUrl: "https://www.cnerh-nov54.dz/storage/documents_files/yiW658Sbif9OSnRPLaC83SqEFTCN9wIVwki3Sck5.pdf", mediaType: "pdf" },
          { id: 59, title: "kifah elmara", qrCodeUrl: "https://www.cnerh-nov54.dz/storage/documents_files/5r9CNeza5717vnEuQke9K7rVfF6t4w7RlvA0Ojwn.pdf", mediaType: "pdf" },
          { id: 60, title: "أشغال الملتقى الوطني الأول الموسوم الذاكرة وإشكالية كتابة التاريخ", qrCodeUrl: "https://www.cnerh-nov54.dz/storage/documents_files/SyLCQHtkclQRNvsYvkLkgKyBMWFdGPqLeSvsjPvR.pdf", mediaType: "pdf" },
          { id: 61, title: "أعمال الملتقى الدولي الجزائر في الوطن العربي", qrCodeUrl: "https://www.cnerh-nov54.dz/storage/documents_files/3NxrFzMR9OQTGkOs3mbremRh0vPKMve3xizxjpe1.pdf", mediaType: "pdf" },
          { id: 62, title: "أعمال الملتقى الدولي حول نشأة وتطور جيش التحرير الوطني", qrCodeUrl: "https://www.cnerh-nov54.dz/storage/documents_files/DcKnIGUPAwsAZY3Oh1XmE9weO2WIPKSIevfbXeCT.pdf", mediaType: "pdf" },
          { id: 63, title: "أعمال الملتقيات والندوات الوطنية المقاومة والثورة في الجنوب الجزائري", qrCodeUrl: "https://www.cnerh-nov54.dz/storage/documents_files/Q1GNPvqIC85SaDPtPOt1giv5poojjViaut71aaRA.pdf", mediaType: "pdf" },
          { id: 64, title: "استراتيجية الثورة في مواجهة الحركات المناوئة", qrCodeUrl: "https://www.cnerh-nov54.dz/storage/documents_files/2j7CckVGfIxxn7O7L5XhsiSy3oFFxQlspq4i3LHy.pdf", mediaType: "pdf" },
          { id: 65, title: "الأسلاك الشائكة", qrCodeUrl: "https://www.cnerh-nov54.dz/storage/documents_files/KBWeMa6GdB1gvheJkZ03IyoLXU6xpsJsH6IldPng.pdf", mediaType: "pdf" },
          { id: 66, title: "الإعلام ومهامه أثناء الثورة", qrCodeUrl: "https://www.cnerh-nov54.dz/storage/documents_files/8SmBwtzbONCGEDE6UcdG2ax9eUglhSkCIr4psPKr.pdf", mediaType: "pdf" },
          { id: 67, title: "الاستعمار بين الحقيقة التاريخية والجدل السياسي", qrCodeUrl: "https://www.cnerh-nov54.dz/storage/documents_files/2sMTUjx5H62raYGAFmTHZHAFRpVwqMwHTM8sl5MY.pdf", mediaType: "pdf" },
          { id: 68, title: "التسليح والمواصلات", qrCodeUrl: "https://www.cnerh-nov54.dz/storage/documents_files/Ot320ZceC2KqKbZQl6GWEd2My4M9BvFHxdqnCUgu.pdf", mediaType: "pdf" },
          { id: 69, title: "التعليم الأهلي في الجزائر في عهد الاحتلال", qrCodeUrl: "https://www.cnerh-nov54.dz/storage/activities/ImOZooVzu5zJWjsykNkBelKMgOX4PPfifnXKGtqs.pdf", mediaType: "pdf" },
          { id: 70, title: "التعليم في الجزائر أثناء الاحتلال", qrCodeUrl: "https://www.asjp.cerist.dz/en/PresentationRevue/29", mediaType: "link" },
          { id: 71, title: "العقار في الجزائر ابان الاحتلال الفرنسي", qrCodeUrl: "https://www.cnerh-nov54.dz/storage/activities/yymrOhNZYZaK1NFREkPQ9f6vPoOaZHMQ35adv3eh.pdf", mediaType: "pdf" },
          { id: 72, title: "القضاء إبان الثورة", qrCodeUrl: "https://www.cnerh-nov54.dz/storage/activities/eHHMWZ3BxpQzjGtOSSu2ijdk37sIlcELMjIeZdvE.pdf", mediaType: "pdf" },
          { id: 73, title: "المقاربات الأكاديمية في جمع الشهادات الحية", qrCodeUrl: "https://www.cnerh-nov54.dz/storage/activities/XHLvkfNBeZCn6NwJLQge2bUTXc5Q7LzG03Bpmzkp.pdf", mediaType: "pdf" },
          { id: 74, title: "الملتقى الدولي حول آثار التجارب النووية في العالم", qrCodeUrl: "https://www.cnerh-nov54.dz/storage/activities/Ggt2L27JRywuLOSYeCuSs8XnpWr1zDvZ6vISuNcZ.pdf", mediaType: "pdf" },
          { id: 75, title: "الهجرة الجزائرية ابان مرحلة الاحتلال", qrCodeUrl: "https://www.cnerh-nov54.dz/storage/documents_files/tvm7XlPoKa4KLUwypQu2nAJZ8npCKykx9fCkiR1l.pdf", mediaType: "pdf" },
          { id: 76, title: "دور الزوايا", qrCodeUrl: "https://www.cnerh-nov54.dz/storage/documents_files/BYyXL5YTP1P6u9qmzApDMr7RxeTDaTxLqZeICSuo.pdf", mediaType: "pdf" },
          { id: 77, title: "فصل الصحراء", qrCodeUrl: "https://www.cnerh-nov54.dz/storage/documents_files/eoxXf6hs4jHcxBY88ZF8xPndUUTYkGs6g3BWye2Y.pdf", mediaType: "pdf" },
          { id: 78, title: "كتاب أصدقاء الثورة", qrCodeUrl: "https://www.cnerh-nov54.dz/storage/documents_files/ngcTgh1kaRsdpxyFzCNBRaqBQtGcUKMKUDRJd7jT.pdf", mediaType: "pdf" },
          { id: 79, title: "معركة الجرف", qrCodeUrl: "https://www.cnerh-nov54.dz/storage/documents_files/ef7q2QCcOKMlQ6rWlDgoQmB27O5Gd6vYna1J4ZXr.pdf", mediaType: "pdf" },
          { id: 80, title: "من أمن الذاكرة الوطنية إلى مناعة الأمة السيادية", qrCodeUrl: "https://www.cnerh-nov54.dz/storage/documents_files/QnYBpFpJtls8gMFL2SVGZlxGXYLIsGi5UHrluqOX.pdf", mediaType: "pdf" },
          { id: 81, title: "واقع الدراسات التاريخية في الجزائر المقاومة والثورة نموذجا", qrCodeUrl: "https://www.cnerh-nov54.dz/storage/documents_files/xYDUr8q3Rl1Jbs0CqUKNPUoBD6kRSI8sV7EDAtFh.pdf", mediaType: "pdf" }
        ],
        count: 28
      }
    ];

    setCategories(categories);
    setBooks(cnerhPublications);
    setQrCodeCategories(qrCodeData);
    setLoading(false);
  }, []);

  useEffect(() => {
    if (selectedCategory) {
      // Filter books by selected category
      const allBooks = [
        {
          id: 1,
          title: "الذكرى الـ 45 لعيد الاستقلال",
          titleEn: "45th Anniversary of Independence",
          titleFr: "45ème Anniversaire de l'Indépendance",
          category: "الذكرى ال45 للاستقلال",
          categoryEn: "45th Independence Anniversary",
          categoryFr: "45ème Anniversaire de l'Indépendance",
          pdfUrl: `/api/visitor/cnerh/pdf/1`,
          coverImage: `/api/visitor/cnerh/cover/1`,
          description: "منشورات الذكرى الـ 45 لعيد الاستقلال",
          year: 2007
        },
        {
          id: 2,
          title: "الذكرى الـ 50 لعيد الاستقلال",
          titleEn: "50th Anniversary of Independence",
          titleFr: "50ème Anniversaire de l'Indépendance",
          category: "الذكرى ال50 لعيد الاستقلال",
          categoryEn: "50th Independence Anniversary",
          categoryFr: "50ème Anniversaire de l'Indépendance",
          pdfUrl: `/api/visitor/cnerh/pdf/2`,
          coverImage: `/api/visitor/cnerh/cover/2`,
          description: "منشورات الذكرى الـ 50 لعيد الاستقلال",
          year: 2012
        },
        {
          id: 3,
          title: "الذكرى الــ 55 لاندلاع الثورة التحريرية",
          titleEn: "55th Anniversary of the Liberation Revolution",
          titleFr: "55ème Anniversaire de la Révolution de Libération",
          category: "الذكرى ال55 للثورة",
          categoryEn: "55th Revolution Anniversary",
          categoryFr: "55ème Anniversaire de la Révolution",
          pdfUrl: `/api/visitor/cnerh/pdf/3`,
          coverImage: `/api/visitor/cnerh/cover/3`,
          description: "منشورات الذكرى الـ 55 لاندلاع الثورة التحريرية",
          year: 2009
        },
        {
          id: 4,
          title: "دليل الإصدرات 60 الثورة",
          titleEn: "Guide to Publications - Revolution 60",
          titleFr: "Guide des Publications - Révolution 60",
          category: "دليل اصدارات الثورة 60",
          categoryEn: "Revolution 60 Publications Guide",
          categoryFr: "Guide des Publications Révolution 60",
          pdfUrl: `/api/visitor/cnerh/pdf/4`,
          coverImage: `/api/visitor/cnerh/cover/4`,
          description: "دليل الإصدارات بمناسبة الذكرى الـ 60 للثورة التحريرية",
          year: 2014
        },
        {
          id: 5,
          title: "للاستقلال بمناسبـة الذكرى الــ 60",
          titleEn: "For Independence - 60th Anniversary",
          titleFr: "Pour l'Indépendance - 60ème Anniversaire",
          category: "دليل اصدارات الاستقلال 60",
          categoryEn: "Independence 60 Publications Guide",
          categoryFr: "Guide des Publications Indépendance 60",
          pdfUrl: `/api/visitor/cnerh/pdf/5`,
          coverImage: `/api/visitor/cnerh/cover/5`,
          description: "دليل الإصدارات بمناسبة الذكرى الـ 60 للاستقلال",
          year: 2022
        },
        {
          id: 6,
          title: "بمناسبة الذكرى الـ 65 لاندلاع الثورة التحريرية",
          titleEn: "65th Anniversary of the Liberation Revolution",
          titleFr: "65ème Anniversaire de la Révolution de Libération",
          category: "دليل الإصدارات الثورة 65",
          categoryEn: "Revolution 65 Publications Guide",
          categoryFr: "Guide des Publications Révolution 65",
          pdfUrl: `/api/visitor/cnerh/pdf/6`,
          coverImage: `/api/visitor/cnerh/cover/6`,
          description: "دليل الإصدارات بمناسبة الذكرى الـ 65 لاندلاع الثورة التحريرية",
          year: 2019
        },
        {
          id: 7,
          title: "منشورات المركز",
          titleEn: "Center Publications",
          titleFr: "Publications du Centre",
          category: "منشورات المركز",
          categoryEn: "Center Publications",
          categoryFr: "Publications du Centre",
          pdfUrl: `/api/visitor/cnerh/pdf/7`,
          coverImage: `/api/visitor/cnerh/cover/7`,
          description: "منشورات المركز الوطني للدراسات والبحث في الحركة الوطنية وثورة أول نوفمبر 1954",
          year: 2023
        }
      ];
      
      const filteredBooks = allBooks.filter(book => book.category === selectedCategory.name);
      setBooks(filteredBooks);
      setCurrentPage(1);
    }
  }, [selectedCategory]);

  const handleSearch = (query) => {
    setSearchQuery(query);
    
    if (searchTimeout) {
      clearTimeout(searchTimeout);
    }

    if (query.trim() === '') {
      setSearchResults([]);
      setIsSearching(false);
      return;
    }

    setIsSearching(true);
    const timeout = setTimeout(() => {
      // Filter books by search query
      const filteredBooks = books.filter(book => 
        book.title.toLowerCase().includes(query.toLowerCase()) ||
        book.description.toLowerCase().includes(query.toLowerCase()) ||
        book.category.toLowerCase().includes(query.toLowerCase())
      );
      setSearchResults(filteredBooks);
      setIsSearching(false);
    }, 500);

    setSearchTimeout(timeout);
  };

  const handleBookClick = (book) => {
    setSelectedBook(book);
    setShowPdfModal(true);
  };

  const closePdfModal = () => {
    setShowPdfModal(false);
    setSelectedBook(null);
  };

  const getCurrentBooks = () => {
    if (searchQuery.trim() !== '') {
      return searchResults;
    }
    return books;
  };

  const getTotalPages = () => {
    const totalBooks = getCurrentBooks().length;
    return Math.ceil(totalBooks / booksPerPage);
  };

  const getCurrentPageBooks = () => {
    const currentBooks = getCurrentBooks();
    const startIndex = (currentPage - 1) * booksPerPage;
    const endIndex = startIndex + booksPerPage;
    return currentBooks.slice(startIndex, endIndex);
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const renderPagination = () => {
    const totalPages = getTotalPages();
    if (totalPages <= 1) return null;

    const pages = [];
    const maxVisiblePages = 5;
    let startPage = Math.max(1, currentPage - Math.floor(maxVisiblePages / 2));
    let endPage = Math.min(totalPages, startPage + maxVisiblePages - 1);

    if (endPage - startPage + 1 < maxVisiblePages) {
      startPage = Math.max(1, endPage - maxVisiblePages + 1);
    }

    for (let i = startPage; i <= endPage; i++) {
      pages.push(
        <button
          key={i}
          onClick={() => handlePageChange(i)}
          className={`pagination-btn ${currentPage === i ? 'active' : ''}`}
        >
          {i}
        </button>
      );
    }

    return (
      <div className="pagination-container">
        <button
          onClick={() => handlePageChange(currentPage - 1)}
          disabled={currentPage === 1}
          className="pagination-btn"
        >
          {t('common.previous')}
        </button>
        {pages}
        <button
          onClick={() => handlePageChange(currentPage + 1)}
          disabled={currentPage === totalPages}
          className="pagination-btn"
        >
          {t('common.next')}
        </button>
      </div>
    );
  };

  const renderBookCard = (book) => (
    <div key={book.id} className="cnerh-book-card" onClick={() => handleBookClick(book)}>
      <div className="book-cover-container">
        <img 
          src={book.coverImage} 
          alt={book.title} 
          className="book-cover-image"
          onError={(e) => {
            e.target.src = '/assets/images/default-book-cover.jpg';
          }}
        />
        <div className="book-overlay">
          <div className="book-year">{book.year}</div>
          <div className="book-category-badge">{book.category}</div>
        </div>
      </div>
      <div className="book-info">
        <h3 className="book-title">{book.title}</h3>
        <p className="book-description">{book.description}</p>
        <div className="book-meta">
          <span className="book-category">{book.category}</span>
          <span className="book-year-meta">{book.year}</span>
        </div>
        <div className="book-actions">
          <button className="view-pdf-btn">
            <i className="fas fa-eye"></i>
            {t('books.details.view')}
          </button>
        </div>
      </div>
    </div>
  );

  const renderQrCodeCard = (item) => {
    return (
      <div key={item.id} className="qr-code-card" onClick={() => window.open(item.qrCodeUrl, '_blank')}>
        <div className="qr-code-cover">
          <div className="qr-code-overlay">
            <div className="qr-code-icon">
              <i className="fas fa-book"></i>
            </div>
          </div>
        </div>
        <div className="qr-code-info">
          <h4 className="qr-code-title">{item.title}</h4>
          <div className="qr-code-actions">
            <button 
              className="qr-code-btn"
              onClick={(e) => {
                e.stopPropagation();
                window.open(item.qrCodeUrl, '_blank');
              }}
            >
              <i className="fas fa-external-link-alt"></i>
              {t('header.view')}
            </button>
          </div>
        </div>
      </div>
    );
  };

  if (loading && categories.length === 0) {
    return (
      <div className="loading-container">
        <div className="spinner"></div>
        <p>{t('loading')}</p>
      </div>
    );
  }

  return (
    <div className="cnerh-container">
      <div className="container">
        <div className="row">
          <div className="col-12">
            <div className="page-header" style={{'--hero-bg-image': `url(${heroImage})`}}>
              <h1>{t('header.cnerh')}</h1>
              <p className="page-description">
                {t('publicationsDropdown.cnerh')}
              </p>
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-12">
            <div className="tabs-container">
              <div className="tabs-header">
                <button
                  className={`tab-btn ${activeTab === 'publications' ? 'active' : ''}`}
                  onClick={() => setActiveTab('publications')}
                >
                  <i className="fas fa-book"></i>
                  {t('cnerh.pdfPublications')}
                </button>
                <button
                  className={`tab-btn ${activeTab === 'qr-media' ? 'active' : ''}`}
                  onClick={() => setActiveTab('qr-media')}
                >
                  <i className="fas fa-book-open"></i>
                  {t('cnerh.digitalPublications')}
                </button>
              </div>
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-md-3">
            <div className="categories-sidebar">
              <h3>{t('search.categories')}</h3>
              <div className="search-container">
                <input
                  type="text"
                  placeholder={t('search.placeholderSearch')}
                  value={searchQuery}
                  onChange={(e) => handleSearch(e.target.value)}
                  className="search-input"
                />
                {isSearching && <div className="search-spinner"></div>}
              </div>
              
              <div className="categories-list">
                <button
                  className={`category-btn ${activeTab === 'publications' ? (selectedCategory === null ? 'active' : '') : ''}`}
                  onClick={() => {
                    setActiveTab('publications');
                    setSelectedCategory(null);
                  }}
                >
                  {t('search.field.all')}
                </button>
                {activeTab === 'publications' && categories.map((category) => (
                  <button
                    key={category.id}
                    className={`category-btn ${selectedCategory?.id === category.id ? 'active' : ''}`}
                    onClick={() => setSelectedCategory(category)}
                  >
                    {category.name}
                  </button>
                ))}
                {activeTab === 'qr-media' && qrCodeCategories.map((category, index) => (
                  <button
                    key={index}
                    className={`category-btn ${selectedQrCategory?.category === category.category ? 'active' : ''}`}
                    onClick={() => setSelectedQrCategory(category)}
                  >
                    {category.translations.ar}
                  </button>
                ))}
              </div>
            </div>
          </div>

          <div className="col-md-9">
            <div className="content-section">
              {loading ? (
                <div className="loading-container">
                  <div className="spinner"></div>
                  <p>{t('loading')}</p>
                </div>
              ) : (
                <>
                  {activeTab === 'publications' && (
                    <>
                      <div className="cnerh-books-grid">
                        {getCurrentPageBooks().map(renderBookCard)}
                      </div>
                      
                      {getCurrentBooks().length === 0 && (
                        <div className="no-books-message">
                          <p>{t('no-item')}</p>
                        </div>
                      )}
                      
                      {renderPagination()}
                    </>
                  )}
                  
                  {activeTab === 'qr-media' && (
                    <>
                      {selectedQrCategory ? (
                        <div className="qr-category-section">
                          <div className="qr-category-header">
                            <h3>{selectedQrCategory.translations.ar}</h3>
                            <p className="qr-category-count">{selectedQrCategory.count} items</p>
                          </div>
                          <div className="qr-codes-grid">
                            {selectedQrCategory.items.map(renderQrCodeCard)}
                          </div>
                        </div>
                          ) : (
                            <div className="qr-categories-overview">
                              <h3>{t('cnerh.digitalPublications')} Categories</h3>
                          <div className="qr-categories-grid">
                            {qrCodeCategories.map((category, index) => (
                              <div key={index} className="qr-category-card" onClick={() => setSelectedQrCategory(category)}>
                                <div className="qr-category-cover">
                                  <div className="qr-category-overlay">
                                    <div className="qr-category-icon">
                                      <i className="fas fa-folder-open"></i>
                                    </div>
                                  </div>
                                </div>
                                <div className="qr-category-info">
                                  <h4>{category.translations.ar}</h4>
                                  <p>{category.count} items</p>
                                </div>
                              </div>
                            ))}
                          </div>
                        </div>
                      )}
                    </>
                  )}
                </>
              )}
            </div>
          </div>
        </div>
      </div>

      {showPdfModal && selectedBook && (
        <div className="pdf-modal-overlay" onClick={closePdfModal}>
          <div className="pdf-modal-content" onClick={(e) => e.stopPropagation()}>
            <div className="pdf-modal-header">
              <h3>{selectedBook.title}</h3>
              <button className="close-btn" onClick={closePdfModal}>
                <i className="fas fa-times"></i>
              </button>
            </div>
            <div className="pdf-modal-body">
              <iframe
                src={selectedBook.pdfUrl}
                width="100%"
                height="600px"
                title={selectedBook.title}
              />
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default CNERH;
